/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'RECRUITMENT_AND_HIRING',
              'TERMINATION_AND_RETRENCHMENT',
              'FACILITY_WORKPLACE_RULES',
              'CHILD_LABOR_AND_YOUNG_WORKERS',
              'PROHIBITION_OF_FORCED_LABOR',
              'ANTI_HARASSMENT_AND_ABUSE',
              'ANTI_DISCRIMINATION',
              'WORKING_HOURS',
              'WAGES_AND_BENEFITS',
              'DISCIPLINE',
              'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
              'GRIEVANCE_SYSTEMS',
              'WORKER_FEEDBACK',
              'HEALTH_AND_SAFETY',
              'FOREIGN_MIGRANT_WORKERS',
              'DOMESTIC_MIGRANT_WORKERS',
              'HOMEWORKERS',
              'SUPPLIERS_SUBCONTRACTORS',
              'RAW_MATERIALS_SOURCING',
              'BRIBERY_AND_ANTI_CORRUPTION',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_have_been_assigned_to_a_responsib: valueSchema,
  },
}
